export interface UserSettings {
  id: number;
  layoutType: UserSettingsLayoutType;
}

export enum UserSettingsLayoutType {
  BOXED = 'LAYOUT.BOXED',
  FULL = 'LAYOUT.FULL',
}
